export { default } from "./NewsArticleFooter";
